import React, { useState, useEffect, useCallback } from "react";

import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import "./SkillSelect.scss";

const SkillSelect = (props) => {
  const [activeOption, setActiveOption] = useState();

  const getFirstOp = useCallback(
    (options) => {
      const firstOp = options?.find((op) => op.default) ?? options?.[0];
      setActiveOption(firstOp);
    },
    [setActiveOption]
  );

  useEffect(() => {
    if (props?.options) getFirstOp(props.options);
  }, [props?.options, getFirstOp]);

  return (
    <div className="skillSelect">
      <UncontrolledButtonDropdown direction="down" className="w-100">
        <DropdownToggle caret color="light" 
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={{
            whiteSpace: 'pre-wrap',
          }}
          >
          {activeOption?.label ?? props.placeholder}
          <i className="bx bx-down-arrow"></i>
        </DropdownToggle>
        <DropdownMenu>
          {props.options.map((op, key) => (
            <DropdownItem
              key={key}
              className="w-100"
              style={{
                whiteSpace: 'pre-wrap',
              }}
              onClick={(e) => {
                e.stopPropagation();
                setActiveOption(op);
                props?.onChange(op);
              }}
            >
              {op.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
};
export default SkillSelect;
